module.exports = __webpack_public_path__ + "static/media/bring-front.b34b797a.svg";